export default __webpack_public_path__ + "static/media/brand-story-hiaru.48d563ee.png";